:host {
  display: block;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
}

/* Gallery Section */
.gallery-section {
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* Header */
.gallery-header {
  text-align: left;
  margin-bottom: 3rem;
}

.gallery-subtitle {
  color: #f97316;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin: 0 0 0.75rem 0;
}

.gallery-title {
  color: #1e293b;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* Grid */
.brands-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

/* Brand Card */
.brand-card {
  background: #ffffff;
  border-radius: 1rem;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 2px solid #2e1065;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.brand-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(46, 16, 101, 0.2);
}

.brand-card:focus {
  outline: 3px solid #f97316;
  outline-offset: 2px;
}

.brand-image-container {
  position: relative;
  background: #f5f3f0;
  padding: 2rem;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}

.brand-image {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
}

.brand-overlay-handle {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.75);
  color: #ffffff;
  padding: 0.5rem 0.75rem;
  border-radius: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.instagram-icon {
  width: 1rem;
  height: 1rem;
}

.brand-info {
  background: #2e1065;
  padding: 1.25rem 1.5rem;
  color: #ffffff;
}

.brand-name {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.brand-location {
  font-size: 0.875rem;
  margin: 0;
  opacity: 0.9;
  font-weight: 400;
}

/* Overlay */
.gallery-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(30, 41, 59, 0.95);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  padding-top: calc(60px + 1.5rem); /* Account for sticky header */
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.overlay-content {
  position: relative;
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 0.5rem;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  z-index: 10;
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.close-button svg {
  width: 1.5rem;
  height: 1.5rem;
}

/* Gallery Container */
.gallery-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  touch-action: pan-y;
}

.gallery-image-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 0;
}

.gallery-image {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 0.75rem;
  background: #1e293b;
}

.gallery-info {
  text-align: center;
  color: #ffffff;
}

.gallery-info h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.brand-story {
  font-size: 1rem;
  line-height: 1.6;
  margin: 0.75rem 0 1rem 0;
  opacity: 0.9;
  font-style: italic;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.image-counter {
  font-size: 0.875rem;
  margin: 0;
  opacity: 0.7;
}

/* Navigation Buttons */
.nav-button {
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: #ffffff;
  cursor: pointer;
  padding: 1rem;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.nav-button:hover {
  background: rgba(249, 115, 22, 0.9);
  border-color: #f97316;
  transform: scale(1.1);
}

.nav-button svg {
  width: 1.5rem;
  height: 1.5rem;
  stroke-width: 3;
}

/* Dots Navigation */
.gallery-dots {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  padding: 1rem;
}

.dot {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
}

.dot:hover {
  background: rgba(255, 255, 255, 0.5);
  transform: scale(1.2);
}

.dot.active {
  background: #f97316;
  width: 2rem;
  border-radius: 0.375rem;
}

/* Tablet Responsive (Framer: 810px - 1199px) */
@media (max-width: 1199px) {
  .gallery-section {
    padding: 3rem 1.5rem;
  }

  .gallery-title {
    font-size: 2rem;
  }

  .brands-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

/* Mobile Responsive (Framer: 0px - 809px) */
@media (max-width: 809px) {
  .gallery-section {
    padding: 2rem 1rem;
  }

  .gallery-header {
    margin-bottom: 2rem;
  }

  .gallery-subtitle {
    font-size: 0.75rem;
  }

  .gallery-title {
    font-size: 1.5rem;
  }

  .brands-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .brand-card {
    max-width: 100%;
    width: 100%;
  }

  .gallery-overlay {
    padding: 1rem;
  }

  .gallery-container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 2.5rem;
    height: 2.5rem;
    z-index: 10;
  }

  .nav-button-prev {
    left: 0.5rem;
  }

  .nav-button-next {
    right: 0.5rem;
  }

  .gallery-image {
    max-height: 50vh;
  }

  .gallery-info h3 {
    font-size: 1.25rem;
  }

  .brand-story {
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0.5rem 0 0.75rem 0;
  }

  .close-button {
    top: 0.5rem;
    right: 0.5rem;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .brand-card,
  .nav-button,
  .dot,
  .gallery-overlay {
    animation: none;
    transition: none;
  }
}

/* Print Styles */
@media print {
  .gallery-overlay {
    display: none;
  }
}
